module.exports = "../../static/img/platform.b72dcd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iconActive/platform.png
// module id = t+DY
// module chunks = 9